import React from "react";

/** Card */
export const Karta = ({ children, style }) => (
  <div
    style={{
      border: "1px solid #e6e9ee",
      borderRadius: 16,
      padding: 16,
      background: "#fff",
      boxShadow: "0 16px 48px rgba(16,24,40,0.16), 0 8px 22px rgba(16,24,40,0.12)",
      ...style,
    }}
  >
    {children}
  </div>
);

/** Section wrapper (supports custom title styles + icon color) */
export const Sekcja = ({ title, icon: Icon, children, titleStyle }) => (
  <Karta>
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
      {Icon ? <Icon size={18} color={titleStyle?.color} /> : null}
      <h3
        style={{
          margin: 0,
          fontSize: 16,
          color: "#111827",
          textDecoration: "none",
          textUnderlineOffset: 3,
          ...titleStyle,
        }}
      >
        {title}
      </h3>
    </div>
    {children}
  </Karta>
);

/** One row: label (with icon) on the left, value on the right */
export const RowIcon = ({ icon: Icon, label, children }) => (
  <div className="kvRow kvCols">
    <div className="kvLabel">
      {Icon ? <Icon size={14} /> : null}
      <span>{label}</span>
    </div>
    <div className="kvValue">{children ?? <em>—</em>}</div>
  </div>
);

/** Monospace helper */
export const mono = (v) =>
  v ? (
    <span style={{ fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace", letterSpacing: 0.3, fontWeight: 700 }}>
      {v}
    </span>
  ) : (
    <em>—</em>
  );

/** Responsive CSS once per page */
export const ResponsiveStyles = () => (
  <style>{`
    .kvRow {
      display: grid;
      gap: 10px;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px dashed #eef1f5;
    }
    .kvCols {
      grid-template-columns: minmax(280px, 360px) 1fr;
    }
    .kvLabel {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      color: #6b7280;
      font-weight: 600;
      min-width: 0;
    }
    .kvValue {
      font-weight: 600;
      min-width: 0;
      word-break: break-word;
    }

    .sectionGrid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 16px;
    }
    .fullRow { grid-column: 1 / -1; }
    .preWrap { white-space: pre-wrap; line-height: 1.4; }

    /* ≤1024px → one column + narrower label */
    @media (max-width: 1024px) {
      .sectionGrid { grid-template-columns: 1fr; }
      .kvCols { grid-template-columns: minmax(180px, 42%) 1fr; }
    }
  `}</style>
);
